"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionMethods = exports.TransactionOperation = void 0;
const enums_1 = require("@finbackoffice/enums");
var TransactionOperation;
(function (TransactionOperation) {
    TransactionOperation["ReferralLiveCasinoRollback"] = "Referral.LiveCasino.rollback";
    TransactionOperation["ReferralLiveCasino"] = "Referral.LiveCasino";
    TransactionOperation["ReferralCasinoRollback"] = "Referral.Casino.rollback";
    TransactionOperation["ReferralCasino"] = "Referral.Casino";
    TransactionOperation["ReferralSportRollback"] = "Referral.Sport.rollback";
    TransactionOperation["ReferralSport"] = "Referral.Sport";
    TransactionOperation["MultibetSport"] = "Multibet.Sport";
    TransactionOperation["CashbackLiveCasinoRollback"] = "Cashback.LiveCasino.rollback";
    TransactionOperation["CashbackLiveCasino"] = "Cashback.LiveCasino";
    TransactionOperation["AgentLiveCasinoCashback"] = "Agent.LiveCasino.Cashback";
    TransactionOperation["AgentLiveCasinoReferral"] = "Agent.LiveCasino.Referral";
    TransactionOperation["CashbackCasinoRollback"] = "Cashback.Casino.rollback";
    TransactionOperation["CashbackCasino"] = "Cashback.Casino";
    TransactionOperation["CashbackCustomCasino"] = "Cashback.CustomCasino";
    TransactionOperation["AgentCasinoCashback"] = "Agent.Casino.Cashback";
    TransactionOperation["AgentCasinoReferral"] = "Agent.Casino.Referral";
    TransactionOperation["CashbackSportRollback"] = "Cashback.Sport.rollback";
    TransactionOperation["CashbackSport"] = "Cashback.Sport";
    TransactionOperation["AgentSportCashback"] = "Agent.Sport.Cashback";
    TransactionOperation["AgentSportReferral"] = "Agent.Sport.Referral";
    TransactionOperation["GuessWin"] = "guess.win";
    TransactionOperation["BetPlace"] = "bet.place";
    TransactionOperation["BetRollback"] = "bet.rollback";
    TransactionOperation["BetRefund"] = "bet.refund";
    TransactionOperation["Debit"] = "debit";
    TransactionOperation["DebitRollback"] = "debit.rollback";
    TransactionOperation["BetWin"] = "bet.win";
    TransactionOperation["Credit"] = "credit";
    TransactionOperation["Withdrawal"] = "withdrawal";
    TransactionOperation["WithdrawalRollback"] = "withdrawal.rollback";
    TransactionOperation["Deposit"] = "deposit";
})(TransactionOperation || (exports.TransactionOperation = TransactionOperation = {}));
exports.TransactionMethods = [
    {
        source: enums_1.TransactionSource.Sport,
        operation: [TransactionOperation.BetRollback],
    },
    {
        source: enums_1.TransactionSource.Bonus,
        operation: [TransactionOperation.CashbackCasinoRollback],
    },
    {
        source: enums_1.TransactionSource.Bonus,
        operation: [
            TransactionOperation.CashbackCasino,
            TransactionOperation.CashbackCustomCasino,
            TransactionOperation.AgentCasinoCashback,
        ],
    },
    {
        source: enums_1.TransactionSource.Bonus,
        operation: [TransactionOperation.AgentCasinoReferral],
    },
    { source: enums_1.TransactionSource.Casino, operation: [TransactionOperation.Debit] },
    {
        source: enums_1.TransactionSource.Casino,
        operation: [TransactionOperation.DebitRollback],
    },
    {
        source: enums_1.TransactionSource.Casino,
        operation: [TransactionOperation.Credit],
    },
    {
        source: enums_1.TransactionSource.Payment,
        operation: [TransactionOperation.Deposit],
    },
    {
        source: enums_1.TransactionSource.Bonus,
        operation: [TransactionOperation.GuessWin],
    },
    {
        source: enums_1.TransactionSource.Bonus,
        operation: [TransactionOperation.CashbackLiveCasinoRollback],
    },
    {
        source: enums_1.TransactionSource.Bonus,
        operation: [
            TransactionOperation.CashbackLiveCasino,
            TransactionOperation.AgentLiveCasinoCashback,
        ],
    },
    {
        source: enums_1.TransactionSource.Bonus,
        operation: [TransactionOperation.ReferralSportRollback],
    },
    {
        source: enums_1.TransactionSource.Bonus,
        operation: [TransactionOperation.ReferralSport],
    },
    {
        source: enums_1.TransactionSource.Bonus,
        operation: [TransactionOperation.ReferralCasinoRollback],
    },
    {
        source: enums_1.TransactionSource.Bonus,
        operation: [TransactionOperation.ReferralLiveCasinoRollback],
    },
    {
        source: enums_1.TransactionSource.Bonus,
        operation: [TransactionOperation.ReferralCasino],
    },
    {
        source: enums_1.TransactionSource.Bonus,
        operation: [TransactionOperation.ReferralLiveCasino],
    },
    {
        source: enums_1.TransactionSource.Bonus,
        operation: [TransactionOperation.AgentSportReferral],
    },
    {
        source: enums_1.TransactionSource.Bonus,
        operation: [TransactionOperation.AgentLiveCasinoReferral],
    },
    {
        source: enums_1.TransactionSource.Bonus,
        operation: [TransactionOperation.CashbackSportRollback],
    },
    {
        source: enums_1.TransactionSource.Bonus,
        operation: [
            TransactionOperation.CashbackSport,
            TransactionOperation.AgentSportCashback,
        ],
    },
    {
        source: enums_1.TransactionSource.Sport,
        operation: [TransactionOperation.BetPlace],
    },
    {
        source: enums_1.TransactionSource.Sport,
        operation: [TransactionOperation.BetRefund],
    },
    { source: enums_1.TransactionSource.Sport, operation: [TransactionOperation.BetWin] },
    {
        source: enums_1.TransactionSource.Bonus,
        operation: [TransactionOperation.MultibetSport],
    },
    {
        source: enums_1.TransactionSource.Payment,
        operation: [TransactionOperation.Withdrawal],
    },
    {
        source: enums_1.TransactionSource.Payment,
        operation: [TransactionOperation.WithdrawalRollback],
    },
];
//# sourceMappingURL=transactions.js.map